import React from "react";

interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  label?: React.ReactNode;
  helpText?: string;
  infoText?: string;
  errorText?: string;
  titleShade?: "light" | "dark";
  className?: string;
  required?: boolean;
  rightElement?: React.ReactNode;
}

const TextInput: React.FC<TextInputProps> = ({
  title,
  label,
  helpText,
  infoText,
  errorText,
  titleShade = "dark",
  className = "",
  required,
  rightElement,
  ...inputProps
}) => {
  const displayLabel = label || title;

  return (
    <div className="flex flex-col gap-2">
      {displayLabel && (
        <label
          className={`block text-sm font-medium ${titleShade === "light" ? "text-white" : "text-gray-700"}`}
        >
          {displayLabel}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      {infoText && <p className="text-gray-600 text-sm">{infoText}</p>}
      <div className="relative flex items-center">
        <input
          id={`input-${displayLabel?.toString().toLowerCase().split(" ").join("-")}`}
          type="text"
          className={`p-2 rounded border w-full ${
            errorText ? "border-danger" : "border-gray-300"
          } focus:outline-none focus:ring-2 ${
            errorText ? "focus:ring-danger" : "focus:ring-info"
          } ${rightElement ? "pr-10" : ""} ${className}`}
          required={required}
          {...inputProps}
        />
        {rightElement && (
          <div className="absolute right-2 flex items-center pointer-events-none">
            {rightElement}
          </div>
        )}
      </div>
      {helpText && !errorText && (
        <p className="text-xs text-gray-500 mt-1">{helpText}</p>
      )}
      {errorText && <p className="text-xs text-danger pt-1">{errorText}</p>}
    </div>
  );
};

export { TextInput };
